export default __webpack_public_path__ + "static/media/jeans.f0398383.webp";